import './style.scss';
import $ from 'jquery';
import gsap from 'gsap';
import Player from '@vimeo/player';

function popupFunction() {
	if($(".wp-block-thefuturblocks-popup").length) {
		$(".wp-block-thefuturblocks-popup").each(function() {
			const self = $(this),
				cont = self.find(".wp-block-thefuturblocks-popup__inner-wrapper"),
				wrapper = self.find(".wp-block-thefuturblocks-popup__button-wrapper"),
				click = self.find(".wp-block-thefuturblocks-popup__button"),
				close = self.find(".wp-block-thefuturblocks-popup__close"),
				vimeoEmb = self.find(".wp-block-embed-vimeo"),
				iframe = self.find('iframe'),
				tl = gsap.fromTo(cont,{autoAlpha:0}, {duration: 0.5, autoAlpha:1, paused:true});
				let player,
				flag = false;
			if(vimeoEmb.length) {
				player = new Player(iframe);
			}
		    click.on("click", () => {
		    	tl.play()
		    	if(vimeoEmb.length) {
		    		player.play()
				}
				flag = true;
		    });
		    close.on("click", () => {
		    	tl.reverse()
		    	if(vimeoEmb.length) {
		    		player.pause()
				}
				flag = false;
		    });

		    $('.wp-block-thefuturblocks-popup__inner-overlay').on("click", () => {
		    	if(flag) {
		    	console.log('ásd');
		    		tl.reverse()
			    	if(vimeoEmb.length) {
			    		player.pause()
					}
		    	}
		    });

		    wrapper.on("mousemove", callMoveIn);
			wrapper.on("mouseleave", callMoveOut);

			function callMoveIn(e){
			  moveIn(e, click, 50);
			}

			function callMoveOut(){
			  moveOut(click);
			}

			function moveIn(e, target, movement){
			  var boundingRect = wrapper[0].getBoundingClientRect();
			  var relX = e.clientX - boundingRect.left;
			  var relY = e.clientY - boundingRect.top;

			  gsap.to(target, {
			    duration: 0.3,
			    x: (relX - boundingRect.width/2) / boundingRect.width * movement,
			    y: (relY - boundingRect.height/2) / boundingRect.width * movement,
			    ease: "sine.out",
			    overwrite: "auto"
			  });
			}

			function moveOut(target){
			  gsap.to(target, {
			    duration: 0.3,
			    x: 0,
			    y: 0,
			    overwrite: "auto"
			  });
			}
		});
	}
}

popupFunction();